<router-outlet></router-outlet>
@if (!isAuthPage()) {
  <app-help-widget></app-help-widget>
}